﻿import { IComponent, Component, Inject, Input, Output, Binding } from "@fiqas/angular-utils"
import { FIQAssist } from "../../app"
import { FileItem } from "./fileDropdownList"
import { IIdentityLink, IResourceResolver } from "../../interfaces/iFqs"
import { SessionService } from "../../services/session"
import * as Rx from "rxjs";
import { Person } from "../../models/person";
import { concat } from "rxjs/operator/concat";
import { retry } from "rxjs/operator/retry";
import { Correspondence } from "../../models/serviceCase";
import { RecordHistory } from "../../models/recordHistory";
import { AuthorizationService } from "../../services/authorizationService";

@Component({
    module: FIQAssist,
    selector: "conversation",
    templateUrl: "views/conversation.html",
})
export class Conversation {
    constructor(
        @Inject('$filter') private $filter: ng.IFilterService,
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$timeout') private $timeout: angular.ITimeoutService,
        @Inject('$scope') private $scope: angular.IScope,
        @Inject() private session: SessionService,
        @Inject() private authorisationService: AuthorizationService
    ) {

    }

    @Input() public readOnly: boolean;
    private _items: ConversationItem[];
    private _conversationdata: ConversationSection[];
    private _initialized: boolean = false;
    private fullsize: boolean = false;
    private _files: FileItem[];
    private _expandAll: boolean;
    private _showAlerts: boolean;
    private _showInternal: boolean;
    private scrollDiv: ng.IAugmentedJQuery;
    private scrollTooltipDiv: ng.IAugmentedJQuery;
    private headerElement: ng.IAugmentedJQuery;
    private disposables: (() => void)[] = [];
    private scrollTooltipSubject: Rx.Subject<void>;

    private get showAlerts() {
        return this._showAlerts;
    }

    private set showAlerts(value: boolean) {
        let old = this._showAlerts;
        this._showAlerts = value;
        if (old !== this._showAlerts)
            this.showAlertsChanged({ value: this._showAlerts })
    }

    private onShowAlertsChanged(active: boolean) {
        this.showAlerts = active;
        this.session.setValue<boolean>("conversation.showAlerts", active);
    }

    private get showInternal() {
        return this._showInternal;
    }

    @Input()
    private set showInternal(value: boolean) {
        let old = this._showInternal;
        this._showInternal = value;
        if (old !== this._showInternal)
            this.showInternalChanged({ value: this._showInternal })
    }

    private onShowInternalChanged(active: boolean) {
        this.showInternal = active;
        this.session.setValue<boolean>("conversation.showInternal", active);
    }

    @Output() public showAlertsChanged: (args: { value: boolean }) => void;

    @Output() public showInternalChanged: (args: { value: boolean }) => void;

    @Input() public showInternalToggle: boolean;

    @Input() public expanded: boolean;

    @Input() public get conversation(): ConversationItem[] {
        return this._items;
    }
    public set conversation(items: ConversationItem[]) {
        if (this._initialized) {
            if (items) {
                items.forEach(async (conversationItem) => {
                    if (conversationItem.direction == "none") return "";
                    var contact: Person = await conversationItem.contactPerson.value;
                    if (contact.phone && contact.phone.length > 0) {
                        conversationItem.phone = `${contact.name}: ${contact.phone.join(", ")}`;
                    }
                });
            }
            this._items = items;

            this.buildSections();
        }
    }

    public allowTypeChange(item: ConversationItem) {
        return this.showInternalToggle && this.authorisationService.currentRole == "SD" && (item.class == 'internal' || (item.class == 'generalNote' && item.fromFiqas));
    }

    @Input() public newFileTooltip: boolean;
    @Input() public newFileTooltext: string;

    @Input() public get files(): FileItem[] {
        return this._files;
    }
    public set files(files: FileItem[]) {
        if (this._initialized)
            this._files = files;
    }

    @Output() public onsizeclicked: (args: { fullsize: boolean }) => void;
    @Output() public onfileclicked: (args: { file: FileItem }) => void;
    @Output() public onfiledeleted: (args: { file: FileItem }) => void;
    @Output() public onTypeChangeClick: (args: { id: IIdentityLink }) => void;

    $onInit() {
        this._initialized = true;
        let s = this.session.getValue<boolean>("conversation.showAlerts");
        this.showAlerts = s !== undefined ? s : true;
        let i = this.session.getValue<boolean>("conversation.showInternal");
        this.showInternal = s !== undefined ? i : true;

        this.scrollTooltipSubject = new Rx.Subject<void>();
        var sub = this.scrollTooltipSubject.debounceTime(1000).subscribe(() => {
            this.displayScrollTooltip = false;
            this.$scope.$applyAsync();
        });
        this.disposables.push(() => sub.unsubscribe());
        this.expandAll = true;
    }

    $onDestroy() {
        this.disposables.forEach(d => {
            try {
                d();
            } catch (e) {

            }
        });
    }

    $postLink() {
        this.headerElement = angular.element(this.$element[0].getElementsByClassName('conversation-header').item(0));
        this.scrollDiv = angular.element(this.$element[0].getElementsByClassName('conversation-scroll').item(0));
        this.scrollTooltipDiv = angular.element(this.$element[0].getElementsByClassName('scroll-tooltip').item(0))
        this.scrollDiv.bind('scroll', $event => this.onConversationScroll($event));
    }

    @Output() public onLayoutAjust: (arge: {}) => void;
    private onConversationScroll($event: BaseJQueryEventObject) {
        var scrollDivScrollPostion = (<HTMLDivElement>this.scrollDiv[0]).scrollTop;
        var scrollDivHeight = (<HTMLDivElement>this.scrollDiv[0]).offsetHeight;
        var scrollDivScrollHeight = (<HTMLDivElement>this.scrollDiv[0]).scrollHeight;
        var heightMargin = scrollDivHeight * (scrollDivScrollPostion / (scrollDivScrollHeight - scrollDivHeight));
        var elements: HTMLDivElement[] = [];
        for (var elem of this.scrollDiv[0].getElementsByClassName('conversation-section'))
            elements.push(elem);
        elements = elements.filter(h => (scrollDivScrollPostion + heightMargin) >= h.offsetTop && (h.offsetTop + h.offsetHeight) >= (scrollDivScrollPostion + heightMargin));
        if (elements.length > 0) {
            this.scrollTooltip = (<HTMLDivElement>elements[0].getElementsByClassName('section-header')[0]).innerText;
            this.displayScrollTooltip = true;
            var scrollFactor = (scrollDivScrollHeight - (scrollDivScrollHeight - scrollDivScrollPostion)) / scrollDivScrollHeight;
            var t = (scrollDivHeight * scrollFactor) + (<HTMLDivElement>this.headerElement[0]).offsetHeight;
            this.scrollTooltipDiv.css("top", t + "px");
            this.$scope.$applyAsync();
            this.scrollTooltipSubject.next();
        }
        if (this.onLayoutAjust) this.onLayoutAjust({});
    }

    private changeConversationType(id: IIdentityLink) {
        this.onTypeChangeClick({ id: id });
    }

    public scrollTooltip = "";
    public displayScrollTooltip = false;

    private async buildSections() {
        if (this._items != null) {
            let items = this._items.sort((a, b) => a.timestamp > b.timestamp ? 1 : -1);
            let data: ConversationSection[] = [];
            let dayTag: Date = new Date(0);
            let direction: Direction = null;
            let section: ConversationSection = null;
            let side: ConversationSide = null;
            items.forEach(x => {
                if (dayTag.toDateString() != x.timestamp.toDateString()) {
                    dayTag = x.timestamp;
                    if (section != null) {
                        section.conversationSides.push(side);
                        data.push(section);
                    }
                    section = { title: this.makeTitle(x.timestamp), conversationSides: [] };
                    direction = x.direction;
                    side = { side: direction, conversationItems: [] };
                } else {
                    if (x.direction != direction) {
                        section.conversationSides.push(side);
                        direction = x.direction;
                        side = { side: direction, conversationItems: [] };
                    }
                }
                side.conversationItems.push(x);
            });
            if (section != null) {
                section.conversationSides.push(side);
                data.push(section);
            }
            this._conversationdata = data;
            await this.$timeout();
            // Hide/show the expand buttons.
            let els = this.$element[0].getElementsByClassName('conversation-item');
            for (let i = 0; i < els.length; i++) {
                let el = els[i];
                let outermsg = el.querySelector('.outer-message');
                let innermsg = outermsg.querySelector('.inner-message');
                let btn = angular.element(el.querySelector('.expand-option'));
                if (innermsg.clientHeight > outermsg.clientHeight)
                    btn.addClass("can-expand")
                else
                    btn.removeClass("can-expand")
            }
            if (this.expandAll && this._items)
                this._items.forEach(i => i.expanded = true);
            await this.$timeout();

            // move to bottom of scroll to show most recent entries.
            this.scrollDiv[0].scrollTop = this.scrollDiv[0].scrollHeight;
        }
    }

    private makeTitle(timestamp: Date): string {
        if (timestamp.toDateString() == new Date().toDateString())
            return "TODAY";
        else {
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            if (timestamp.toDateString() == yesterday.toDateString())
                return "YESTERDAY";
            else
                return this.$filter('date')(timestamp, 'd MMM yyyy');
        }
    }

    public onSizeClick(event: Event) {
        this.fullsize = !this.fullsize;
        this.onsizeclicked({ fullsize: this.fullsize });
    }

    public get expandAll() {
        return this._expandAll;
    }

    public set expandAll(expand: boolean) {
        var old = this._expandAll;
        this._expandAll = expand;
        if (old != expand && this._items)
            this._items.forEach(x => x.expanded = expand);
    }

    public onExpandAll(status: boolean) {
        this.expandAll = status;
    }

    public itemToggle(item: ConversationItem) {
        item.expanded = !item.expanded;
        if (this._items.every(i => !i.expanded))
            this._expandAll = false;
        else if (this._items.every(i => i.expanded))
            this._expandAll = true;
    }

    public onFileClick(fileRef: IIdentityLink) {
        let file = this._files.filter(x => x.id.href == fileRef.href).shift();
        this.onfileclicked({ file: file });
    }

    public onFileDelete(fileRef: IIdentityLink) {
        let file = this._files.filter(x => x.id.href == fileRef.href).shift();
        this.onfiledeleted({ file: file });
    }

    private isfocus: boolean = false;

    public onFocus() {
        this.isfocus = true;
    }

    public onBlur() {
        this.isfocus = false;
    }
}

export type Direction = "in" | "out" | "none";

export interface ConversationItem {
    id: IIdentityLink,
    person: string;
    contactPerson: IResourceResolver<Person>;
    phone: string;
    timestamp: Date;
    direction: Direction;
    text: string;
    expanded?: boolean;
    class?: string;
    fromFiqas?: boolean;
    fromSupport?: boolean;
    item: Correspondence | RecordHistory;
}

interface ConversationSide {
    side: Direction;
    conversationItems: ConversationItem[];
}

interface ConversationSection {
    title: string;
    conversationSides: ConversationSide[];
}

